// @flow

import { DEFAULT_PROFILE_PHOTO } from 'utils/constants'

export function getProfilePhotoUrl(url?: string) {
  // return any profile photo URL except for default SVG
  if (url !== DEFAULT_PROFILE_PHOTO) {
    return url
  }
}
